import { Search } from "lucide-react";
import React from "react";

import { IgBorderColors, IgTextField } from "@intelligems/ig-theme";
import { useDispatch, useSelector } from "@src/store";
import {
  getProductPickerSearch,
  setProductPickerSearch,
} from "@src/store/slices/productPicker";

export const ProductSearch = () => {
  const search = useSelector(getProductPickerSearch);
  const dispatch = useDispatch();

  return (
    <IgTextField
      placeholder={"Search products"}
      value={search}
      onChange={(e) => void dispatch(setProductPickerSearch(e.target.value))}
      InputProps={{
        endAdornment: <Search size={16} />,
      }}
    />
  );
};
